<template>
  <div class="editEmployeeSkillVue">
   
    <div class="c-responsive-fixwidth">
        <div class="clearfix o-skillset-area">
            <div class="employer-info">
                <div class="field-group">
                    <div class="row">
                        <div class="col-sm-12">
                            <div class="c-common-space c-radius3">
                                <div class="col-sm-3 skillset o-no-padding"><span class="common-label-text">{{ $t('authority') }}:</span>
                                    <ul>
                                        <li>
                                            <form>
                                                <div class="radio o-custom-radio">
                                                   <label>
                                                       {{ $t('locked') }} 
                                                       <input type="radio" name="o3" v-model="updateAuthority" value="locked" @change="onUpdateAuthorityChange(updateAuthority)" :disabled="logInUserType != 'client-admin' && logInUserType != 'power-user' || logInUserType == 'power-user-minus'">
                                                       <span class="cr"><i class="cr-icon fa fa-circle"></i></span>
                                                   </label>
                                               </div>
                                               <div class="radio o-custom-radio">
                                                   <label>
                                                       {{ $t('unlocked') }} 
                                                       <input type="radio" name="o3" v-model="updateAuthority" value="unlocked" @change="onUpdateAuthorityChange(updateAuthority)" :disabled="logInUserType != 'client-admin' && logInUserType != 'power-user' || logInUserType == 'power-user-minus'">
                                                       <span class="cr"><i class="cr-icon fa fa-circle"></i></span>
                                                   </label>
                                               </div>
                                            </form>
                                        </li>
                                    </ul>
                                </div>
                                <div class="col-sm-9 skillset">
                                   <span class="common-label-text">{{ $t('action') }}:</span>
                                    <button @click="selectAllSkill()" type="submit" class="c-common-btn c-common-btn--small o-no-margin" :class="(selectedFilter == 'all')?'o-filter-active':''" :disabled="logInUserType == 'power-user-minus' || ((logInUserType != 'client-admin' && logInUserType != 'power-user') && updateAuthority=='locked')">{{ $t('all') }} </button>
                                   <button @click="selectNone()" type="submit" class="c-common-btn c-common-btn--small o-no-margin" :class="(selectedFilter == 'none')?'o-filter-active':''" :disabled="logInUserType == 'power-user-minus' || ((logInUserType != 'client-admin' && logInUserType != 'power-user') && updateAuthority=='locked')">{{ $t('none') }} </button>
                                </div>

                            </div>
                            <div class="c-common-space c-common-box-shadow c-radius3">
                                <div class="c-user-tab-content clearfix o-skillset-area">
                                    <div v-loading="loading" class="row">
                                        <form class="common-scroll">
                                            <div v-for="(skill,skillIndex) in skillList" :key="skillIndex" class="col-sm-3">
                                                <div class="checkbox o-custom-checkbox clearfix">
                                                    <label v-if="updateAuthority">
                                                        {{skill.name}} 
                                                        <span v-if="getSkillSeniority(skill.id)">
                                                            ({{ getSkillSeniority(skill.id) }})
                                                        </span>
                                                       <input type="checkbox" name="o4" :value="skill.id" v-model="selectedSkills" @change="onUpdateInputField" :disabled="checkEditSkillInProfile(skill)">
                                                       <!-- <input type="checkbox" name="o4" :value="skill.id" v-model="selectedSkills" @change="onUpdateInputField" :disabled="(logInUserType != 'client-admin' && logInUserType != 'power-user' && updateAuthority=='locked' && checkEditSkillInProfile(skill))"> -->
                                                       <span class="cr"><i class="cr-icon fa fa-check"></i></span>
                                                   </label>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
            
  </div>
</template>
<script>
    import {
        bus
    } from '../../main';
    import service from '../../services.js';
    import {
        mapGetters,
        mapActions
    } from 'vuex';
    export default {
        props: {
            empDetails: {
                type: Object,
                required: true
            }
        },
        data() {
            return {
                selectedFilter: 'all',
                skillList: [],
                tempSelectedSkills: [],
                selectedSkills: [],
                loading: false,
                updateAuthority: 'locked',
                logInUserType: '',
                configSkillLock:'',
            }
        },
        computed: {
            ...mapGetters({
                userToken: 'userToken',
                userRole: 'userRole',
                userRoleSlug: 'userRoleSlug',
                userClientID: 'userClientID',
                currentEmployeeID: 'currentEmployeeID',
            })
        },
        watch: {
            empDetails: function(newData) {
                this.updateAuthority = (newData.skill_lock) ? 'locked' : 'unlocked';
                //this.selectedSkills = newData.selectedSkills;
                this.configSkillLock = this.newData.configSkillLock;
                this.onUpdateInputField();
            }
        },
        methods: {
            checkEditSkillInProfile(skill){
                if(this.logInUserType == 'power-user-minus')
                    return true;

                let name = skill.name.toLowerCase();
                let result = (name == 'steward' || name == 'dispatched by' || name == 'rss feed' || name == 'penalty rules') ? true : false;

                if(this.updateAuthority == 'unlocked' && this.logInUserType != 'client-admin' && this.logInUserType != 'power-user' && result)
                    return true;

                if(this.updateAuthority == 'locked' && this.logInUserType != 'client-admin' && this.logInUserType != 'power-user')
                    return true;

                return false;
            },
            getSkillSeniority(id) {
                let index = this.empDetails.skill_seniority.findIndex((item) => item.skill_id === id )
                if(index !== -1) {
                    return this.empDetails.skill_seniority[index].seniority
                }
            },
            checkAccesspower() {
                let logInUser = this.$cookies.get('csLogin');
                // console.log(logInUser);
                // if(this.updateAuthority=='locked' && logInUser != 'client-admin' || logInUser != 'power-user' ){
                //     console.log(this.updateAuthority, logInUser);
                //     return true;
                // }else{
                //     return false;
                // }
            },
            selectAllSkill() {
                if(this.userRoleSlug == 'client-admin' || this.userRoleSlug == 'power-user') {
                    this.selectedFilter = 'all';
                    let self = this;
                    this.skillList.forEach((skill) => {
                        var name = skill.name.toLowerCase();
                        let result = (name == 'steward') || (name == 'dispatched by') || (name == 'rss feed') || (name == 'penalty rules')
                            // console.log(result);
                        if(self.updateAuthority == 'locked') {
                            self.selectedSkills.push(skill.id);
                        }else if(self.updateAuthority == 'unlocked'){
                            // console.log(name);
                            if(!result)
                                self.selectedSkills.push(skill.id);
                        }
                    });
                    this.onUpdateInputField();
                }
            },
            selectNone() {
                if(this.userRoleSlug == 'client-admin' || this.userRoleSlug == 'power-user') {
                    this.selectedFilter = 'none';
                    let self = this;
                    if(self.updateAuthority == 'locked') {
                            self.selectedSkills = [];
                    }
                    else if (self.updateAuthority == 'unlocked') {
                        this.skillList.forEach((skill) => {  
                            let name = skill.name.toLowerCase();
                            let result = (name == 'steward') || (name == 'dispatched by') || (name == 'rss feed') || (name == 'penalty rules');                       
                            if(!result){
                                // console.log(name + " " + result)
                                // this.selectedSkills = [];
                                let skill_index = -1
                                self.selectedSkills.forEach((item) => {
                                    skill_index = skill_index + 1
                                    if(item == skill.id) {
                                        self.selectedSkills.splice(skill_index, 1);
                                    }
                                })
                            }      
                                        
                        }); 
                    }               
                    this.onUpdateInputField();
                }
            },
            onUpdateAuthorityChange() {
                this.selectedSkills = this.tempSelectedSkills;
                this.onUpdateInputField(this.updateAuthority);
            },
            onUpdateInputField(updateAuthority = null) {
                let self =this;
                // this.selectedSkills = this.tempSelectedSkills;
                if(updateAuthority == 'locked' || updateAuthority == 'unlocked'){
                        this.empDetails.skills.forEach(function(skill) {
                        self.selectedSkills.push(skill.id);
                        // self.tempSelectedSkills.push(skill.id);
                        //console.log(emp.employable.id);
                    });
                }
                //this.$store.dispatch('saveEmployeeBasicInfo', this.empPersonal.basicInfo);
                let skillData = {
                    selectedSkills: this.selectedSkills,
                    updateAuthority: this.updateAuthority,
                    configSkillLock:this.configSkillLock,
                };
                bus.$emit('onUpdateSkillList', skillData);
            }
        },
        created() {
            //this.selectedSkills = this.empDetails.skills;
            //console.log(this.skillList);
            this.logInUserType = this.$cookies.get('csLogin');
            //console.log(this.logInUserType);
            this.updateAuthority = (this.empDetails.skill_lock) ? 'locked' : 'unlocked';
            this.configSkillLock = this.empDetails.configSkillLock;
            // if(this.configSkillLock == 1 && this.logInUserType != 'client-admin' && this.logInUserType != 'power-user')
            //     this.updateAuthority = 'locked';
            // console.log('DATA', this.configSkillLock);
            let self = this;
            this.empDetails.skills.forEach(function(skill) {
                self.selectedSkills.push(skill.id);
                self.tempSelectedSkills.push(skill.id);
                //console.log(emp.employable.id);
            });
            this.onUpdateInputField();
            this.loading = true;
            service.get('skill/getAllSkills', {
                'Authorization': this.userToken,
                'cs3-context-role': this.userRole,
                'cs3-context-clientId': this.userClientID
            }).
            then((res) => {
                this.skillList = res.data.result;
                this.loading = false;
                //console.log('SkillAPI', this.skillList);

            }).catch((err) => {
                console.log(err);
                this.loading = false;
            });
            // console.log(this.empDetails.skill_seniority);
        }
    }

</script>
<style scoped>


</style>
